import { createAction, props } from '@ngrx/store';
import { DictionaryPage } from '../company-drill-down/models/dictionary-page.model';
import { SearchCompany } from './models/search-company.model';

export const updateHash = createAction('[Company Search Component] Update Current Search Hash', props<{ hash: string }>());

export const updateSearchInput = createAction('[Company Search Component] Update Current Search Input', props<{ searchInput: string }>());

export const updateNextPage = createAction('[Company Search Component] Update Next Page', props<{ page: number }>());

export const updateCurrentPage = createAction('[Company Search Component] Update Current Page', props<{ page: number }>());

export const addNewSearch = createAction('[Company Search Component] Add New Search', props<{ hash: string; page: number }>());

export const loadCompanies = createAction(
  '[Company Search Component] Load Companies',
  props<{ hash: string; page: number; itemsPerPage: number; searchInput: string }>()
);

export const companiesLoaded = createAction(
  '[Company Search Effects] Companies Loaded',
  props<{ hash: string; page: number; companies: SearchCompany[]; totalCount: number }>()
);

export const companiesLoadFailed = createAction('[Company Search Effects] Companies Load Failed', props<{ hash: string; page: number }>());

export const resetSearch = createAction('[Company Search Component] Reset Search');

export const saveSelectedCompanies = createAction('[Company Search Component] Save Selected Companies', props<{ page: number; ids: any[] }>());

export const clearSelectedCompanies = createAction('[Company Search Component] Clear Selected Companies');

export const clearState = createAction('[Company Search Component] Clear State');

export const selectCompanyDrillDownTab = createAction('[Company Search Component] Select Company Drill Down Tab');

export const sendExternalDataForDrillDown = createAction(
  '[Company Search Component] Send External Data For Drill Down',
  props<{ idsByPage: DictionaryPage; count: number; rows: number }>()
);

export const sendNavigationDataForDrillDown = createAction(
  '[Company Search Component] Send Navigation Data For Drill Down',
  props<{ page: number; index: number }>()
);

export const sendSelectedComparableIdForDrillDown = createAction(
  '[Company Search Component] Send Selected Comparable Id For Drill Down',
  props<{ id: number }>()
);

export const getPageDataForDrillDown = createAction(
  '[Company Search Component] Get Page Data For Drill Down',
  props<{ page: number; index: number }>()
);

export const pageDataForDrillDownLoaded = createAction(
  '[Company Search Effects] Page Data For Drill Down Loaded',
  props<{ page: number; index: number; companies: SearchCompany[] }>()
);

export const pageDataForDrillDownLoadFailed = createAction(
  '[Company Search Effects] Page Data For Drill Down Load Failed',
  props<{ page: number }>()
);

export const removeNonStudyComparables = createAction('[Company Search Component] Remove Non Study Comparables');
